import { Component, ChangeDetectionStrategy, Input, ChangeDetectorRef } from '@angular/core';
import { AbstractControl, UntypedFormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { AutoUnsubscribe } from '../../common';
import { ErrorType, PATTERN_TRANSLATION_KEY_MAP } from './field-error-messages.constant';
import { ValidationPatterns } from '../../modular-validation/validation';

type PatternKey = Extract<keyof ValidationPatterns, string>;

type ControlWithPatternKey = AbstractControl & {
  __patternKey?: PatternKey;
};

@Component({
  selector: 'ui-field-error-messages',
  templateUrl: './field-error-messages.component.html',
  styleUrls: ['./field-error-messages.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
@AutoUnsubscribe
export class FieldErrorMessages {
  @Input() set control(c: UntypedFormControl | AbstractControl) {
    this.formControl = c;

    this.subscriptions.push(
      c.valueChanges.subscribe(() => {
        this.cd.detectChanges();
      }),
      c.statusChanges.subscribe(() => {
        this.cd.markForCheck();
      }),
    );
  }

  errorType = ErrorType;
  patternMessageMap = PATTERN_TRANSLATION_KEY_MAP;
  formControl: UntypedFormControl | AbstractControl;

  subscriptions: Subscription[] = [];

  constructor(private cd: ChangeDetectorRef) {}

  getPatternKeyFromAngularError(): string {
    const patternErr = this.formControl?.errors?.pattern;
    const requiredPattern = patternErr?.requiredPattern;

    const mapHit = requiredPattern ? this.patternMessageMap.get(requiredPattern) : undefined;

    const ctrl = this.formControl as ControlWithPatternKey;
    const localKey = ctrl.__patternKey;

    // fallback chain
    return localKey ?? mapHit ?? 'default';
  }
}
